import { Layout } from "./components";
import { useParams } from "react-router-dom";

const Catalog = () => {
  const params: any = useParams();
  return (
    <div className="container">
      <h1 className="title">{params.type}</h1>
      <main style={{ display: "flex" }}>
        <Layout />
      </main>
    </div>
  );
};

export default Catalog;
